import {pageInfo, initPage, saveData, editData} from './../api';
import { wareHouse } from '../../../../api'
import { Message } from 'element-ui';
const box = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initWareHouseObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    INIT_WAREHOUSE_DATA(state, data) {
      state.initWareHouseObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //初始化仓库数据
    async initWareHouseData({ commit }, obj) {
      let resp = await wareHouse(obj);
      commit('INIT_WAREHOUSE_DATA', resp);
    }
  }
}
export default box



// WEBPACK FOOTER //
// ./src/page/md/box/store/box.store.js